import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoadingType } from "../../../types/CommonTypes";
import { getIsrAgencyList, getIsrUserEmailList } from "../../../service/IsrService";
import { useAppSelector } from "../redux-hooks";
import { IsrRecord, IsrUserEmail } from "../../../components/operation/isr/isrTypes";

type IsrState = {
  isrList: IsrRecord[];
  isrUserEmailList: IsrUserEmail[];
  fetchIsrListStatus: LoadingType;
  fetchIsrUserEmailListStatus: LoadingType;
};

const initialState: IsrState = {
  isrList: [],
  isrUserEmailList: [],
  fetchIsrListStatus: "idle",
  fetchIsrUserEmailListStatus: "idle",
};

const mapIsrRecord = (row: any): IsrRecord => ({
  isrId: row?.agencyId,
  fullName: row?.agencyName ?? "",
  email: row?.email ?? "",
  active: !row?.inactiveDate && row?.active !== false,
});

const mapIsrUserEmail = (row: any): IsrUserEmail => ({
  userId: row?.userId,
  email: row?.email ?? "",
  fullName: row?.fullName ?? "",
});

export const fetchIsrList = createAsyncThunk(
  "fetchIsrList",
  async (commissionType?: string) => {
    const payload = commissionType ? { commissionType } : {};
    const response = await getIsrAgencyList(payload);
    return response.data;
  }
);

export const fetchIsrUserEmailList = createAsyncThunk("fetchIsrUserEmailList", async () => {
  const response = await getIsrUserEmailList();
  return response.data;
});

const isrSlice = createSlice({
  name: "isr",
  initialState,
  reducers: {
    resetIsrSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIsrList.pending, (state) => {
        state.fetchIsrListStatus = "loading";
      })
      .addCase(fetchIsrList.fulfilled, (state, action) => {
        state.fetchIsrListStatus = "success";
        const rows = action.payload?.data;
        state.isrList = Array.isArray(rows) ? rows.map(mapIsrRecord) : [];
      })
      .addCase(fetchIsrList.rejected, (state) => {
        state.fetchIsrListStatus = "error";
      })
      .addCase(fetchIsrUserEmailList.pending, (state) => {
        state.fetchIsrUserEmailListStatus = "loading";
      })
      .addCase(fetchIsrUserEmailList.fulfilled, (state, action) => {
        state.fetchIsrUserEmailListStatus = "success";
        const rows = action.payload?.data;
        state.isrUserEmailList = Array.isArray(rows) ? rows.map(mapIsrUserEmail) : [];
      })
      .addCase(fetchIsrUserEmailList.rejected, (state) => {
        state.fetchIsrUserEmailListStatus = "error";
      });
  },
});

export const { resetIsrSlice } = isrSlice.actions;
export const useIsrReducer = () => useAppSelector((state) => state.isrSlice);
export default isrSlice.reducer;
